import React, { Component } from 'react';
import { Dropdown } from 'semantic-ui-react';

const ENV_STORAGE_KEY = 'env';

const envOptions = [
    { key: 'dev', value: 'dev', text: 'Dev' },
    { key: 'prod', value: 'prod', text: 'Prod' },
    { key: 'stage', value: 'stage', text: 'Stage' },
];

class EnvSwitcherDropdown extends Component {
    componentDidMount() {
        if (!localStorage.getItem(ENV_STORAGE_KEY)) {
            localStorage.setItem(ENV_STORAGE_KEY, 'prod');
        }
    }

    getCurrentValue = () => {
        const stored = localStorage.getItem(ENV_STORAGE_KEY);
        if (stored && ['dev', 'prod', 'stage'].includes(stored)) {
            return stored;
        }
        return 'prod';
    };

    onChange = (e, { value }) => {
        localStorage.setItem(ENV_STORAGE_KEY, value);
        window.location.reload();
    };

    render() {
        const value = this.getCurrentValue();

        return (
            <span
                style={{
                    zIndex: '999',
                    fontSize: '115%',
                    marginTop: '6px',
                    color: this.props.color,
                    border: '1px solid ' + this.props.color,
                    padding: '4px',
                    borderRadius: '4px',
                }}
            >
                <Dropdown options={envOptions} onChange={this.onChange} value={value} inline />
            </span>
        );
    }
}

export default EnvSwitcherDropdown;